<template>
  <div id="formulario-edit-info">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vs-prompt color="primary" :active.sync="popupDuplicar.popupActive" title="Duplicar Conta"     
      @accept="duplicarRequest"      
      :is-valid="popupDuplicar.quantidadeDuplicacao > 0 "
      acceptText="Duplicar" cancelText="Fechar">
       <div class="con-exemple-prompt">
            Informe o número de vezes que deseja duplicar:
            <vs-input v-model="popupDuplicar.quantidadeDuplicacao"/>         
       </div>
    </vs-prompt>

    <div id="div-with-loading" class="vs-con-loading__container">
        <vx-card>
            <div class="vx-row mb-4">
                <div class="vx-col md:w-1/2 w-full">                    
                    <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoInserir && temPermissaoAlterar">Gravar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="duplicar" color="dark" v-if="data_local.hasOwnProperty('id')">Duplicar</vs-button>
                    <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable" color="danger" v-if="temPermissaoAlterar">Excluir</vs-button>            
                    <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label">Cliente</label>
                    <v-select          
                        label="nome"                                                 
                        :options="listaFavorecido"                   
                        v-model="data_local.favorecido"     
                        :disabled="isDesabilitarCampo"  
                    class="v-select w-full"></v-select>    
                </div>                  
            </div>
            <div class="vx-row">
                <div class="vx-col w-3/4">
                    <label class="vs-input--label">Descrição do Item</label>
                    <vs-input class="w-full" v-model="data_local.descricaoItem" :maxlength="255" :disabled="isDesabilitarCampo"    />   
                </div>
                <div class="vx-col w-1/4">
                    <label class="vs-input--label">Data da Fatura</label>
                    <flat-pickr v-model="data_local.dataInclusaoFatura" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" :disabled="isDesabilitarCampo"  />
                </div>
            </div>                              
            <div class="vx-row">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Quantidade</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.qtd" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>     
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Valor Unitário</label>
                    <vue-autonumeric class="vs-inputx vs-input--input normal hasValue" :disabled="isDesabilitarCampo" v-model="data_local.precoUnitario" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>                 
                </div>                               
            </div>   
            <div class="vx-row mb-2" v-if="isConcept">               
                <div class="vx-col w-full">
                    <label class="vs-input--label">CNAE</label>                
                    <v-select                                               
                            :options="CONSTANTE_CNAES"                             
                            v-model="data_local.cnaeEmissaoNotaFiscal"  
                            :disabled="isDesabilitarCampo"    
                            :reduce="r => r.data"    
                            @input="onSelectedCnae"                                              
                            class="v-select w-full">
                        </v-select> 
                </div>
            </div>
            <div class="vx-row mb-2" v-if="isConcept">               
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Incluir na Nota Fiscal ?</label>
                    <vs-checkbox class="w-full mt-2" v-model="data_local.incluirEmNotaFiscal" :disabled="isDesabilitarCampo || (data_local.cnaeEmissaoNotaFiscal && !recuperarCnae(data_local.cnaeEmissaoNotaFiscal).emiteNF)"    />   
                </div>
            </div>                 
        </vx-card>  
    </div>    
  </div>
</template>

<script>

import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import { CONSTANTE_CNAES } from  '@/constantesComboBox.js'
const URL_SERVLET = "/ItemContaFuturo";
const NAME_ROUTE_SEARCH = "financeiro-item-conta-futuro-pesquisar";

export default { 
  components: {  
    VueAutonumeric,
    flatPickr
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { favorecido:null, descricaoItem:null, 
            dataInclusaoFatura:null, qtd: null, precoUnitario: null, cnaeEmissaoNotaFiscal: null, incluirEmNotaFiscal: true }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)), 
        listaFavorecido: [],
        configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
        },  
        popupDuplicar: {
            popupActive: false,
            quantidadeDuplicacao: 0
        }, 
    }
  },  
  created(){
    this.CONSTANTE_CNAES = CONSTANTE_CNAES; 
  }, 
  mounted() {
    this.fetchListaFavorecido();
     if (this.data_local != null && this.data_local.hasOwnProperty('id')) {        
        this.$vs.loading();
        this.findById();            
    }
  },
  computed: {
    isDesabilitarCampo(){
        return this.data_local.dataHoraIncluidoFormatado;
    },
    isConcept(){
        return this.$store.state.AppActiveUser.empresa.id === 1;
    },        
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    },    
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoInserir() {
       if ( this.isGestor ) {
            return true;
        } 
        
        if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO' || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER' 
                || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR' || this.$store.state.AppActiveUser.perfil === 'CRM'
                || this.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER') {
            return true;
        }

        return false;
        
    },
    temPermissaoAlterar() {
       if ( this.isGestor ) {
            return true;
        } 

        if (this.data_local !== null && this.data_local.hasOwnProperty("id")) {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') {
                return true;
            }

            return false;
        } 

        return true;
    }
  },
  methods: {  
    recuperarCnae(cnae) {
        const elemento = CONSTANTE_CNAES.find(item => String(item.data) === String(cnae));        
        return elemento;
    },
    onSelectedCnae(cnaeSelecionado) {        
        const elemento = this.recuperarCnae(cnaeSelecionado);  
        this.data_local.incluirEmNotaFiscal =  elemento.emiteNF;
    },
    duplicar(){
       this.popupDuplicar.popupActive = true;
       this.popupDuplicar.quantidadeDuplicacao = 0;
    },
    duplicarRequest(){
         this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
        params.append('quantidadeDuplicacao', this.popupDuplicar.quantidadeDuplicacao);   
                
        axios.post(URL_SERVLET + "/DuplicarItemXVezes", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - duplicarRequest - " + error); 
        })          
    },
    fetchListaFavorecido() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('ehCliente',  true);
      
      axios.post("/Favorecido/ListarFavorecido", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaFavorecido = response.data.Resultado.lista;
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarItemContaFuturo", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.ItemContaFuturo; 
                 if (this.data_local.hasOwnProperty('cnaeEmissaoNotaFiscal')) {
                    this.data_local.cnaeEmissaoNotaFiscal = String(this.data_local.cnaeEmissaoNotaFiscal);
                 }
                 this.fecthListaFavorecidoContatos();                
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverItemContaFuturo", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf("ERRO") != -1) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();

            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append("id", this.data_local.id);
            }
            
            params.append("favorecido.id", this.data_local.favorecido.id);
            params.append("favorecido.nome", this.data_local.favorecido.nome);
            params.append("descricaoItem", this.data_local.descricaoItem);
            params.append("dataInclusaoFatura", this.data_local.dataInclusaoFatura);
            params.append("qtd", this.data_local.qtd);
            params.append("precoUnitario", this.data_local.precoUnitario);  

            if (this.isConcept) {
                if (this.data_local.cnaeEmissaoNotaFiscal) {
                    params.append("cnaeEmissaoNotaFiscal", this.data_local.cnaeEmissaoNotaFiscal);  
                }

                params.append("incluirEmNotaFiscal", this.data_local.incluirEmNotaFiscal);                  
            } else {
                params.append("incluirEmNotaFiscal", true);                  
            }

            axios.post(URL_SERVLET + "/GravarItemContaFuturo", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                                        
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.ItemConta.erroOperacao) {                 
                               
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.ItemConta.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.ItemConta;                          
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
      
        if (!this.data_local.favorecido) { this.errorsValidacao.push("Cliente obrigatório"); }
        if (!this.data_local.descricaoItem) { this.errorsValidacao.push("Descrição do item obrigatório"); }
        if (!this.data_local.dataInclusaoFatura) { this.errorsValidacao.push("Data da Fatura obrigatório"); }
        if (!this.data_local.qtd) { this.errorsValidacao.push("Quantidade obrigatório"); }
        if (!this.data_local.precoUnitario) { this.errorsValidacao.push("Valor Unitário obrigatório"); }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
    
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>